import { render, staticRenderFns } from "./review-specs.vue?vue&type=template&id=430b15b0"
import script from "./review-specs.vue?vue&type=script&lang=ts"
export * from "./review-specs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports